<template lang="pug">
  div.container-cadastro
    .card-header Cadastro de arrecadação
    el-tabs.content(:value="tabSelecionada" @tab-click="mudarTab")
      el-tab-pane(name="pecaTecnica" :disabled="isResumo")
        span(slot="label") Peças Técnicas &nbsp
        validation-observer(ref='observer' tag='form')
          peca-tecnica-arcGis(
            v-if="$route.query.idCadastroColetivo ? cadastroColetivo.id : cadastroColetivo",
            :cadastroColetivo="cadastroColetivo",
            :isValidacao="true"
          )

      el-tab-pane(name="resumo" :disabled="!isResumo")
        span(slot="label") Resumo &nbsp
        resumo-pecas-tecnicas(
          v-if="tabSelecionada === 'resumo'"
          :cadastroColetivo="cadastroColetivo"
          @exibirBotaoFinalizar="exibirBotaoFinalizar()"
        )

    app-buttons-cadastro(
      :isPrimeiroPasso="isPrimeiroPasso",
      :isUltimoPasso="isUltimoPasso",
      :showButtonSalvar="!isUltimoPasso",
      :showButtonProximo="!isUltimoPasso",
      :showButtonFinalizar="showFinalizar",
      @proximo="proximo",
      @salvar="salvarCadastro",
      @voltar="voltar",
      @cancelar="cancelar",
      @finalizar="finalizarCadastro"
    )
</template>

<script>
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import rotas from '@/constants/rotas'
import { mapActions } from 'vuex'
import { cloneDeep, pickBy, identity } from 'lodash'
import PecaTecnicaArcGis from '@/screens/arrecadacao/gat/components/PecaTecnicaArcGis'
import ResumoPecasTecnicas from '@/screens/arrecadacao/gat/components/ResumoPecasTecnicas'

const PECA_TECNICA_EMPTY = {
  area: null,
  perimetro: null,
  geom: null,
  municipios: [],
  documentos: [],
  jsonPlanilha: null,
  tipoPlanilha: null,
  denominacaoImovel: null,
  gleba: null,
  interessado: null,
  geometriaAreaDeduzida: null,
  leituraMapa: null,
  mapaLocalizacao: null,
  memorialDescritivo: null,
  areaDeduzida: null,
  dadoPecaTecnica: {
    id: null,
    documentos: [],
    documentosAutenticavel: [],
    jsonPlanilha: null,
    responsavel: null
  }
}

const CADASTRO_COLETIVO_EMPTY = {
  pecaTecnica: PECA_TECNICA_EMPTY
}

export default {
  mixins: [AppNotificacao],

  data () {
    return {
      cadastroColetivo: cloneDeep(CADASTRO_COLETIVO_EMPTY),
      isResumo: this.$route.query.isResumo === true,
      tabSelecionada: 'pecaTecnica',
      showFinalizar: false
    }
  },

  components: {
    AppButtonsCadastro,
    PecaTecnicaArcGis,
    ResumoPecasTecnicas
  },

  async created () {
    const idCadastroColetivo = this.$route.query.idCadastroColetivo
    if (idCadastroColetivo) {
      const response = await this.findByIdCadastroColetivo(idCadastroColetivo)
      const responsavel = response.pecaTecnica.responsavel
      this.mergeCadastroColetivo(response)
      this.cadastroColetivo.pecaTecnica.dadoPecaTecnica.responsavel = responsavel
    }
    if (this.$route.query.isResumo === 'true') {
      this.tabSelecionada = 'resumo'
    }
  },

  beforeMount () {
    if (this.isResumo) {
      this.tabSelecionada = 'resumo'
    }
  },

  computed: {
    indexTabAtual () {
      return this.tabs.findIndex(tab => tab.name === this.tabSelecionada)
    },

    tabs () {
      const cadastroColetivoId = this.cadastroColetivo.id
      return this.getTabs(cadastroColetivoId)
    },

    isPrimeiroPasso () {
      return this.indexTabAtual === 0
    },

    isUltimoPasso () {
      return this.indexTabAtual === this.tabs.length - 1
    }
  },

  async beforeRouteUpdate (to, from, next) {
    this.validarCampos()
    next()
  },

  methods: {
    ...mapActions({
      salvarCadastroColetivo: 'cadastroColetivo/saveStep',
      findByIdCadastroColetivo: 'cadastroColetivo/findById',
      finalizarCadastroColetivo: 'cadastroColetivo/finalizar',
      tramitarProcessoArrecadacao: 'cadastroColetivo/tramitarProcessoArrecadacao',
      deletarFilaByIdProcesso: 'filaPlantaMemorial/deletarFilaByIdProcesso'
    }),

    mergeGeorreferenciamento (geo) {
      const idGeo = this.cadastroColetivo.georreferenciamento.id

      this.cadastroColetivo.georreferenciamento = geo
      this.cadastroColetivo.georreferenciamento.id = idGeo
    },

    atualizarGeorreferenciamento (geo) {
      this.mergeGeorreferenciamento(geo)
    },

    mergeCadastroColetivo (cadastroColetivo) {
      this.cadastroColetivo = {
        ...cloneDeep(CADASTRO_COLETIVO_EMPTY),
        ...pickBy(cadastroColetivo, identity)
      }
    },

    validarCampos () {
      return this.$refs.observer.validate()
    },

    exibirBotaoFinalizar () {
      this.showFinalizar = true
    },

    async proximo () {
      const isValido = await this.$refs.observer.validate()
      if (!isValido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.VERIFICAR_CAMPOS
        )
        return
      }
      this.confirmBox(
        'Deseja confirmar esta ação?',
        this.$messages.TITULO_WARNING,
        async () => {
          try {
            const tabAtual = this.tabs[this.indexTabAtual]
            let response = await this.salvarCadastroColetivo(
              {
                ...tabAtual.dadosRequest,
                dados: {
                  ...tabAtual.dadosRequest.dados,
                  gleba: tabAtual.dadosRequest.dados?.gleba || '',
                  dadoPecaTecnica: {
                    ...tabAtual.dadosRequest.dados?.dadoPecaTecnica,
                    responsavel: {
                      ...tabAtual.dadosRequest.dados?.dadoPecaTecnica?.responsavel,
                      codigoCredenciamento: tabAtual.dadosRequest.dados?.dadoPecaTecnica?.responsavel?.codigoIncra
                    }
                  }
                }
              }
            )
            this.mergeCadastroColetivo(response)
            this.$nextTick(async () => {
              try {
                const response = await this.finalizarCadastroColetivo(
                  this.cadastroColetivo.id
                )
                const cc = await this.findByIdCadastroColetivo(this.cadastroColetivo.id)
                this.mergeCadastroColetivo(cc)
                this.isResumo = true
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  response
                )
                this.tabSelecionada = 'resumo'
              } catch (error) {
                let message = error.message
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  message
                )
              }
            })
          } catch (error) {
            let message = error.message

            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              message
            )
          }
        },
        () => {},
        'Confimar',
        'Cancelar'
      )
    },

    async salvarCadastro () {
      this.validarCampos()
      const tabAtual = this.tabs[this.indexTabAtual]
      if (tabAtual.dadosRequest.url) {
        try {
          const response = await this.salvarCadastroColetivo(
            {
              ...tabAtual.dadosRequest,
              dados: {
                ...tabAtual.dadosRequest.dados,
                dadoPecaTecnica: {
                  ...tabAtual.dadosRequest.dados?.dadoPecaTecnica,
                  responsavel: {
                    ...tabAtual.dadosRequest.dados?.dadoPecaTecnica?.responsavel,
                    codigoCredenciamento: tabAtual.dadosRequest.dados?.dadoPecaTecnica?.responsavel?.codigoIncra
                  }
                }
              }
            }
          )

          this.mergeCadastroColetivo(response)

          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.DADOS_SALVOS_SUCESSO
          )
        } catch (error) {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            error.message
          )
          throw error
        }
      }
    },

    voltar () {
      if (this.indexTabAtual !== 0) {
        this.$router.push({
          name: 'gat/home'
        })
      }
    },

    cancelar () {
      this.confirmBox(
        'Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.',
        this.$messages.TITULO_WARNING,
        async () => {
          try {
            if (this.isResumo) {
              await this.deletarFilaByIdProcesso(this.cadastroColetivo.processoArrecadacao.id)
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                'Cancelada a geração das peças técnicas'
              )
            }
          } catch (error) {
            console.log('Erro ao deletar fila', error)
            let message = error.message
            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              message
            )
          }
          this.$router.push({
            name: 'gat/home'
          })
        },
        () => {},
        'Sim',
        'Não'
      )
    },

    async finalizarCadastro () {
      this.confirmBox(
        'Deseja confirmar esta ação?',
        this.$messages.TITULO_WARNING,
        async () => {
          try {
            const response = await this.tramitarProcessoArrecadacao(this.cadastroColetivo)
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              response
            )
            this.$router.push({
              name: 'gat/home'
            })
          } catch (error) {
            let message = error.message
            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              message
            )
          }
        },
        () => {},
        'Confimar',
        'Cancelar')
    },

    mudarTab (componente) {
      if (this.isResumo) {
        return
      }
      this.tabSelecionada = componente._props.name
    },

    tabPossuiErro (label) {
      let temErro = false
      if (this.$refs.observer) {
        for (const key in this.$refs.observer.errors) {
          if (
            key.substring(0, key.indexOf('/')) === label &&
            this.$refs.observer.errors[key].length > 0
          ) {
            temErro = true
          }
        }
      }
      return temErro
    },

    getErrosTab (label) {
      let erros = []
      if (this.$refs.observer) {
        for (const key in this.$refs.observer.errors) {
          if (
            key.substring(0, key.indexOf('/')) === label &&
            this.$refs.observer.errors[key].length > 0
          ) {
            const campo = key.substring(key.indexOf('/') + 1, key.length)
            erros.push(`${campo}: ${this.$refs.observer.errors[key][0]}`)
          }
        }
      }
      return erros
    },

    getTabs (cadastroColetivoId) {
      return [
        {
          label: 'Peças Técnicas',
          name: 'pecaTecnica',
          dadosRequest: {
            url: rotas.ARRECADACAO.SALVAR_PECA_TECNICA(cadastroColetivoId),
            dados: this.cadastroColetivo.pecaTecnica
          }
        },
        {
          label: 'Resumo',
          name: 'resumo',
          dadosRequest: null
        }
      ]
    },

    onRemoveGeometria () {

    }
  }
}
</script>

<style lang="scss" scoped>
$font-size-small: 12px;

.container-cadastro {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.content {
  flex: 1;
  padding-top: 10px;
}

.container-tab {
  padding: 10px;
}

pre {
  font-size: $font-size-small;
}
</style>

<!-- Criar migration -->
 <!-- ALTER TABLE arrecadacao.processo ADD COLUMN is_resumo BOOLEAN DEFAULT false; -->



// WEBPACK FOOTER //
// src/screens/arrecadacao/gat/components/cadastroColetivo/CadastroColetivo.vue